/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MaterialItemViewModel } from "../types/MaterialItemViewModel.ts";

export const materialItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  fileName: z.string().nullish(),
  blobPath: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  parentFolderId: z.number().int().nullish(),
  isSlide: z.optional(z.boolean()),
  isFile: z.optional(z.boolean()),
  isPdfSlideClass: z.optional(z.boolean()),
  slides: z.optional(z.number().int()),
  numberOfDownloads: z.optional(z.number().int()),
  creationDate: z.string().datetime().nullish(),
}) as unknown as ToZod<MaterialItemViewModel>;
